module.exports = __webpack_public_path__ + "img/twitter.ac62664c.svg";